import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 10px;
    width: 100%;
`;
